import { z } from 'zod';

// Registration form schema
export const registerSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  company: z.string().min(1, 'Company name is required'),
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters long'),
});

// Login form schema
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  password: z.string().min(1, 'Password is required'),
});

// Configuration form schema
export const configSchema = z.object({
  senderId: z
    .string()
    .min(1, 'Sender ID is required')
    .max(50, 'Sender ID must be less than 50 characters')
    .regex(
      /^[a-zA-Z0-9_-]+$/,
      'Sender ID can only contain letters, numbers, underscores, and hyphens'
    ),
  optimoveBaseUrl: z
    .string()
    .min(1, 'Optimove Base URL is required')
    .url('Please enter a valid URL'),
  optimoveApiToken: z.string().min(1, 'API token is required'),
  optimoveSecretKey: z.string().min(1, 'Secret key is required'),
  providerApiKey: z.string().min(1, 'Provider API key is required'),
  providerSendUrl: z
    .string()
    .min(1, 'Provider Send URL is required')
    .url('Please enter a valid URL'),
});

// Forgot password form schema
export const forgotPasswordSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
});

// Type exports
export type RegisterFormData = z.infer<typeof registerSchema>;
export type LoginFormData = z.infer<typeof loginSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type ConfigFormData = z.infer<typeof configSchema>;
